import Legend from "./Legend/index.js";
import identity from "../util/identity.js"; // eslint-disable-next-line @typescript-eslint/no-explicit-any
import { jsx as _jsx } from "react/jsx-runtime";
function labelFormatterFactoryFactory(_ref) {
  let {
    labelDelimiter
  } = _ref;
  return _ref2 => {
    let {
      scale,
      labelFormat
    } = _ref2;
    return (datum, index) => {
      const [x0, x1] = scale.invertExtent(scale(datum));
      return {
        extent: [x0, x1],
        text: `${labelFormat(x0, index)} ${labelDelimiter} ${labelFormat(x1, index)}`,
        value: scale(x0),
        datum,
        index
      };
    };
  };
}

/** A Quantile scale takes a number input and returns an Output. */
export default function Quantile(_ref3) {
  let {
    domain: inputDomain,
    scale,
    labelFormat = identity,
    labelTransform: inputLabelTransform,
    labelDelimiter = '-',
    ...restProps
  } = _ref3;
  // transform range into input values because it may contain more elements
  const domain = inputDomain || scale.range().map(output => scale.invertExtent(output)[0]);
  const labelTransform = inputLabelTransform || labelFormatterFactoryFactory({
    labelDelimiter
  });
  return /*#__PURE__*/_jsx(Legend, {
    scale: scale,
    domain: domain,
    labelFormat: labelFormat,
    labelTransform: labelTransform,
    ...restProps
  });
}